export default __webpack_public_path__ + "static/media/logo-Kaleidi.abed1439.jpg";